import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/react-query/queryKeys";
import { fetchTenantOptions } from "../services/institutionsService";
import type { TenantOption } from "../types/institution.types";

/** `enabled: false` skips the request (e.g. when the dropdown is not shown). */
export function useTenantOptions(options: { enabled?: boolean } = {}) {
  return useQuery<TenantOption[]>({
    enabled: options.enabled ?? true,
    queryKey: queryKeys.institutions.tenantOptions(),
    queryFn: fetchTenantOptions,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
